const useDecodeHash = () => {
  const decodeHash = <T>({
    failHash: failHashIn,
    successHash: successHashIn,
  }: {
    successHash: string;
    failHash: string;
  }) => {
    const hashValue = window.location.hash;

    const successHash = `#${successHashIn}=`;
    const failHash = `#${failHashIn}=`;

    const isChargeCardSuccess = Boolean(hashValue && hashValue.startsWith(successHash));
    const isChargeCardFailure = Boolean(hashValue && hashValue.startsWith(failHash));

    if (!isChargeCardSuccess && !isChargeCardFailure) return null;

    let replaceStr: string | null = null;

    if (isChargeCardSuccess) {
      replaceStr = successHash;
    }

    if (isChargeCardFailure) {
      replaceStr = failHash;
    }

    if (!replaceStr) {
      return null;
    }

    const savedCardRefString = atob(decodeURIComponent(hashValue.replace(replaceStr, '')));

    if (savedCardRefString) {
      const savedAddCardRef = JSON.parse(savedCardRefString);
      return {
        isSuccess: isChargeCardSuccess,
        isFailure: isChargeCardFailure,
        hasHashValue: true,
        data: savedAddCardRef as T,
      };
    }

    return null;
  };

  return { decodeHash };
};

export default useDecodeHash;
